import type { ReactNode } from 'react';
import { cn } from '@savvy-kit/lib/utils';

type ContentMaxWidth = 'sm' | 'md' | 'lg';

const MAX_WIDTH_CLASS: Record<ContentMaxWidth, string> = {
  sm: 'max-w-[600px]',
  md: 'max-w-[1000px]',
  lg: 'max-w-[1200px]',
};

export function DashboardContent({
  children,
  maxWidth,
}: {
  readonly children: ReactNode;
  readonly maxWidth?: ContentMaxWidth;
}) {
  return (
    <main className="grow py-8">
      <div className={cn('mx-auto w-full', MAX_WIDTH_CLASS[maxWidth ?? 'sm'], maxWidth ? 'px-4 sm:px-6' : '!px-0')}>
        {children}
      </div>
    </main>
  );
}
